import type { RecipeContentRejectionVariant } from '../components/RecipeContentRejectionModal';
import type { MisconductSource, RecipeContentRejectionCode } from '../types';
import { estimateLocalSeverity } from './recipeContentGuard';
import { logMisconductUsage } from './misconductUsage';

export interface ContentRejectionModalState {
    isOpen: boolean;
    variant: RecipeContentRejectionVariant;
}

export async function reportAndShowContentRejection(
    params: {
        userId?: string;
        code: RecipeContentRejectionCode;
        source: MisconductSource;
        textSample?: string;
        severity?: number;
    },
    setModal: (state: ContentRejectionModalState) => void,
): Promise<void> {
    const variant: RecipeContentRejectionVariant =
        params.code === 'inappropriate_content' ? 'misconduct' : 'not_recipe';

    if (params.code === 'inappropriate_content' && params.userId) {
        const severity =
            params.severity ?? estimateLocalSeverity(params.code, params.textSample ?? '');
        try {
            await logMisconductUsage(params.userId, {
                severity,
                code: params.code,
                source: params.source,
                contentLength: params.textSample?.trim().length,
            });
        } catch (err) {
            console.error('Failed to log misconduct usage', err);
        }
    }

    setModal({ isOpen: true, variant });
}
